import { render, staticRenderFns } from "./CalculaBoxModal.vue?vue&type=template&id=442f2252&scoped=true"
import script from "./CalculaBoxModal.vue?vue&type=script&lang=js"
export * from "./CalculaBoxModal.vue?vue&type=script&lang=js"
import style0 from "./CalculaBoxModal.vue?vue&type=style&index=0&id=442f2252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442f2252",
  null
  
)

export default component.exports